/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from "@ember/component";
import { schedule } from "@ember/runloop";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class LinkToInput extends Component {
  showInput = false;

  click() {
    this.onClick();

    schedule("afterRender", () => {
      this.element.querySelector("input").focus();
    });

    return false;
  }

  <template>
    {{#if this.showInput}}
      {{yield}}
    {{else}}
      <a href>
        {{#if this.key}}
          {{i18n this.key}}
        {{/if}}
        {{#if this.icon}}
          {{dIcon this.icon}}
        {{/if}}
      </a>
    {{/if}}
  </template>
}
